// extracted by mini-css-extract-plugin
export default {"rating":"_J-z","numberOfStars":"aK-z","count":"bK-z","barGraphSpacing":"cK-z","barGraph":"dK-z"};